export default function initDonationContacts() {
  const isPresent = document.querySelector(".donation-contacts");
  if (!isPresent) {
    return;
  }

  function toggleDonationContacts() {
    // Select all elements with the class "donation-item"
    const donationItems = document.querySelectorAll(".donation-item");

    // Check if any of the donation items have the class "active"
    const hasActiveItem = Array.from(donationItems).some((item) =>
      item.classList.contains("active")
    );

    // Select the element with the class "donation-contacts"
    const donationContacts = document.querySelector(".donation-contacts");

    // Add or remove the "hidden" class based on whether an active item was found
    if (hasActiveItem) {
      donationContacts.classList.add("hidden");
    } else {
      donationContacts.classList.remove("hidden");
    }
  }

  // Function to observe mutations on .donation-item elements
  function observeDonationItems() {
    const donationItems = document.querySelectorAll(".donation-item");

    // Create a MutationObserver to watch for class changes
    const observer = new MutationObserver(toggleDonationContacts);

    // Observer configuration: watch for changes to attributes (like classes)
    const config = { attributes: true, attributeFilter: ["class"] };

    // Observe each .donation-item element
    donationItems.forEach((item) => {
      observer.observe(item, config);
    });
  }

  // Call the toggle function initially in case any item is already active on page load
  toggleDonationContacts();

  // Start observing the donation items for changes
  observeDonationItems();
}
